import { render, staticRenderFns } from "./CatalogSelector.vue?vue&type=template&id=0c335b2a&scoped=true"
import script from "./CatalogSelector.vue?vue&type=script&lang=js"
export * from "./CatalogSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c335b2a",
  null
  
)

export default component.exports